var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showDocumentSection
    ? _c(
        "div",
        { staticClass: "payment-documents" },
        [
          _c(
            "div",
            {
              staticClass:
                "bg-gray-9 rounded px-2 py-3 d-flex align-items-center cursor-pointer",
              on: { click: _vm.onOpenCloseDocuments }
            },
            [
              _c("em", {
                staticClass: "fad fa-chevron-circle-right collapse-button",
                class: { "fa-rotate-90": _vm.visibleDocuments }
              }),
              _c("span", { staticClass: "color-gray-7 font-weight-bold" }, [
                _vm._v("Documentos")
              ])
            ]
          ),
          _c(
            "b-collapse",
            {
              model: {
                value: _vm.visibleDocuments,
                callback: function($$v) {
                  _vm.visibleDocuments = $$v
                },
                expression: "visibleDocuments"
              }
            },
            _vm._l(_vm.filteredDocuments, function(document, idx) {
              return _c(
                "div",
                {
                  key: `document-$${idx}`,
                  staticClass:
                    "bg-gray-9 rounded py-3 px-4 mt-1 row mx-0 align-items-center"
                },
                [
                  _c("div", { staticClass: "col-12 col-md-5" }, [
                    _vm._v(" " + _vm._s(document.name) + " ")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "col-12 col-md-2",
                      class: {
                        "color-green": document.status,
                        "color-primary-4": document.status === false
                      }
                    },
                    [_vm._v(" " + _vm._s(document.statusDescription) + " ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-5 d-flex justify-content-end align-items-center p-0"
                    },
                    [
                      document.isGenerated &&
                      !document.fileId &&
                      !_vm.documentsDisabled
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-redo-alt",
                              text: "Generar Documento",
                              variant: "outline-success"
                            },
                            on: {
                              click: function($event) {
                                return _vm.generateDocument(document)
                              }
                            }
                          })
                        : _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-file-input", {
                                        key: `fileUpload-$${idx}`,
                                        class: {
                                          "file-input-disabled":
                                            _vm.documentsDisabled
                                        },
                                        attrs: {
                                          accept: document.accept || ".pdf",
                                          "attachment-id": document.fileId,
                                          "custom-error-msg":
                                            "Favor seleccionar un documento.",
                                          disabled: _vm.documentsDisabled,
                                          "display-style": "normal",
                                          error: errors[0],
                                          "max-size": document.maxSize,
                                          name: document.filename,
                                          "on-download": _vm.onDownloadFile,
                                          required: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.onUploadPaymentDocument(
                                              $event,
                                              document.documentTypeId,
                                              document.fileId
                                            )
                                          }
                                        },
                                        model: {
                                          value: document.model,
                                          callback: function($$v) {
                                            _vm.$set(document, "model", $$v)
                                          },
                                          expression: "document.model"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          }),
                      document.fileId &&
                      _vm.documentsDisabled &&
                      document.status !== false
                        ? _c("action-button", {
                            staticClass: "ml-3 download-btn",
                            attrs: {
                              i: "fas fa-file-download",
                              variant: "outline-success"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onDownloadFile(document.fileId)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }